// removed by extract-text-webpack-plugin
module.exports = {"container":"_38A6Plj7wup7wSPWb66-e0","title":"_3PTotq8ROAAbPgcCb6mHqA","image":"_3EOehFTYG2tf-u-rnLCnEa","cost":"_39OTr5uZjH-nD4f0VUUW1U","stock":"_1vS8dgz8iqmbyQP5FM89CZ","location":"_3TkO9Y2AcgDMB-Qbn1wSfm","stockType":"_2Az9hbYhfyMUD1up_BkeL8"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Product/style.scss
// module id = 1241
// module chunks = 0